__turbopack_context__.v({
  "compactWrapper": "_4aVf-a_compactWrapper",
  "title": "_4aVf-a_title",
  "titleWithIcon": "_4aVf-a_titleWithIcon",
  "wrapper": "_4aVf-a_wrapper",
});
